import { render, staticRenderFns } from "./PuList.vue?vue&type=template&id=2b32f55f&scoped=true&"
import script from "./PuList.vue?vue&type=script&lang=js&"
export * from "./PuList.vue?vue&type=script&lang=js&"
import style0 from "./PuList.vue?vue&type=style&index=0&id=2b32f55f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32f55f",
  null
  
)

export default component.exports